import { render, staticRenderFns } from "./BaseFilterSlider.vue?vue&type=template&id=856d42d8&scoped=true"
import script from "./BaseFilterSlider.vue?vue&type=script&lang=ts"
export * from "./BaseFilterSlider.vue?vue&type=script&lang=ts"
import style0 from "./BaseFilterSlider.vue?vue&type=style&index=0&id=856d42d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856d42d8",
  null
  
)

export default component.exports